import React from "react";
import { Heading, Link, Text } from "@telia/teddy";

const Eierskifteskjema: React.FC = () => (
    <div className="retailer-dashboard-wrapper">
        <Heading as="h1" variant="title-300" mb="200">
            Eierskifteskjema
        </Heading>
        <Text>
            Merk at dette vil ta lenger tid enn{" "}
            <Link
                href="https://www.telia.no/eierskifte/bekreft-id/"
                target="_blank"
                rel="noopener noreferrer"
                variant="text"
            >
                digitalt eierskifte
            </Link>
            . Kunden vil få en bekreftelse fra Telia når det er i orden.
        </Text>
        <Heading as="h3" variant="title-100" mt="200" mb="100">
            Framgangsmåte:
        </Heading>
        <ol>
            <li>
                <Text>
                    <Link
                        href="https://www.telia.no/globalassets/pdf/telia_eierskifteskjema.pdf"
                        target="_blank"
                        rel="noopener noreferrer"
                        variant="text"
                    >
                        Last ned eierskifteskjema (PDF)
                    </Link>
                    .
                </Text>
            </li>
            <li>
                <Text>Fyll ut informasjon om både ny og nåværende eier.</Text>
            </li>
            <li>
                <Text>Både nåværende og ny eier signerer skjema.</Text>
            </li>
            <li>
                <Text>Send inn skjema.</Text>
            </li>
        </ol>
        <Text>
            Skjema kan sendes på e-post:{" "}
            <Link href="mailto:skjema-eierskifte@telia.no" variant="text">
                skjema-eierskifte@telia.no
            </Link>
        </Text>
    </div>
);

export default Eierskifteskjema;
